import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import Measure from 'react-measure';
import { GrayButton, SecondaryButton, SocialNetworkIcon, Popover, QueueFlyoutTab, Spinner, WatchClickOutside } from 'components';
import { LLChip, LLSubmitButton, LLButton, LLDropDownList } from 'components/FormElements';
import { HorizontalNav } from 'containers';
import { addQueuePostTime, removeQueuePostTime } from 'redux/modules/contentLibraryQueues';
import styles from './QueueFlyout.scss';
import HorizontalPostCard from './HorizontalPostCard';
var QueueFlyout = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    queues: state.queues["".concat(orgId)] || [],
    theme: state.theme,
    loadingQueues: state.queues.loadingQueues,
    createPostTimeError: state.contentLibrary.createPostTimeError
  };
}, {
  addQueuePostTime: addQueuePostTime,
  removeQueuePostTime: removeQueuePostTime
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(QueueFlyout, _Component);

  var _super = _createSuper(QueueFlyout);

  function QueueFlyout(props) {
    var _this;

    _classCallCheck(this, QueueFlyout);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var hasQueues = !!_this.props.queues.length;

      if (hasQueues) {
        _this.setState({
          selectedQueue: 0,
          open: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "calculateInnerWrapWidth", function () {
      var hasQueues = !!_this.props.queues.length;
      var innerWrapWidth = 325 * (hasQueues ? _this.props.queues[_this.state.selectedQueue].Posts.length : 0);

      _this.setState({
        innerWrapWidth: innerWrapWidth
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleTabClick", function (queueIndex) {
      // Consider this a 'newly selected queue' if one wasn't selected before, or the user clicked a new one
      var isNewQueue = _this.state.selectedQueue === null || _this.state.selectedQueue !== queueIndex;
      var isOpen = false; // If it's not open, or you selected a different queue, open it or leave it open

      if (!_this.state.open || isNewQueue) {
        isOpen = true;
      }

      _this.setState({
        open: isOpen,
        selectedQueue: queueIndex,
        left: 36
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderTabLabel", function (queue) {
      var network = ''; // Wrapping in a try catch just in case we end up with a queue without any social networks

      try {
        network = queue.SocialAccounts[0].platform.split(' ').join('').toLowerCase();
      } catch (e) {
        // TODO: Notify the server that someone's data is somehow messed up.
        network = null;
      }

      var labelTextRaw = queue.SocialAccounts[0].username.toUpperCase();
      var labelText = labelTextRaw.length > 35 ? "".concat(labelTextRaw.substring(0, 32), "...") : labelTextRaw;
      return !network ? null : /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(SocialNetworkIcon, {
        network: network
      }), " ", /*#__PURE__*/React.createElement("span", null, labelText));
    });

    _defineProperty(_assertThisInitialized(_this), "handleRightNav", function () {
      _this.setState({
        left: _this.state.left - _this.state.queueWidth
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleLeftNav", function () {
      _this.setState({
        left: _this.state.left + _this.state.queueWidth
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderAddTimeDialog", function () {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        style: {
          color: _this.props.theme.colors.gray1
        }
      }, "This will add another piece of content each week to your ".concat(_this.state.selectedQueue !== null && _this.props.queues[_this.state.selectedQueue].SocialAccounts ? _this.props.queues[_this.state.selectedQueue].SocialAccounts[0].username : '', " queue.")), /*#__PURE__*/React.createElement("p", {
        style: {
          color: _this.props.theme.colors.gray1
        }
      }, "What day and time would you like this to post?"), /*#__PURE__*/React.createElement(DropDownMenu, {
        value: _this.state.selectedDayOfWeek,
        onChange: _this.postTimeWeekdaySelected,
        style: {
          marginRight: 24
        }
      }, _this.state.daysOfWeek.map(function (d, idx) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          value: idx,
          primaryText: d.title
        });
      })), /*#__PURE__*/React.createElement(DropDownMenu, {
        value: _this.state.selectedTimeOfDay,
        onChange: _this.postTimeOfDaySelected
      }, _this.state.timesOfDay.map(function (d, idx) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          value: idx,
          primaryText: d.title
        });
      })), _this.doesSelectedPostTimeExist() && /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red'
        }
      }, "You already have this post time added to your Queue."), _this.state.addingQueuePostTimeError && /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red'
        }
      }, _this.state.addingQueuePostTimeError));
    });

    _defineProperty(_assertThisInitialized(_this), "addQueuePostTime", function () {
      _this.setState({
        isAddingQueuePostTime: true
      });

      _this.props.addQueuePostTime(_this.props.organization.id, _this.props.queues[_this.state.selectedQueue].id, _this.state.daysOfWeek[_this.state.selectedDayOfWeek], _this.state.timesOfDay[_this.state.selectedTimeOfDay]).then(function (res) {
        _this.props.queues[_this.state.selectedQueue].QueuePostTimes.push(res.data);

        _this.setState({
          isAddingQueuePostTime: false,
          showAddTimeDialog: false,
          selectedDayOfWeek: 0,
          selectedTimeOfDay: 0
        });
      })["catch"](function (err) {
        console.error(err);

        _this.setState({
          isAddingQueuePostTime: false,
          addingQueuePostTimeError: err.error.message
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "postTimeOfDaySelected", function (e, index, value) {
      _this.setState({
        selectedTimeOfDay: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "postTimeWeekdaySelected", function (e, index, value) {
      _this.setState({
        selectedDayOfWeek: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "formatPostTimeChipLabel", function (qpt) {
      var day = '';
      var time = '';

      switch (qpt.weekday) {
        case 1:
          day = 'Monday';
          break;

        case 2:
          day = 'Tuesday';
          break;

        case 3:
          day = 'Wednesday';
          break;

        case 4:
          day = 'Thursday';
          break;

        case 5:
          day = 'Friday';
          break;

        case 6:
          day = 'Saturday';
          break;

        case 7:
          day = 'Sunday';
          break;
      }

      switch (qpt.timeOfDay) {
        case 1:
          time = 'Morning';
          break;

        case 2:
          time = 'Afternoon';
          break;

        case 3:
          time = 'Evening';
          break;
      }

      return "".concat(day, " ").concat(time);
    });

    _defineProperty(_assertThisInitialized(_this), "removeQueuePostTime", function (qpt) {
      _this.props.queues[_this.state.selectedQueue].QueuePostTimes.splice(_this.props.queues[_this.state.selectedQueue].QueuePostTimes.indexOf(qpt), 1);

      _this.forceUpdate();

      _this.props.removeQueuePostTime(qpt.id, _this.props.organization.id).then(function () {})["catch"](function (err) {
        console.error(err);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "doesSelectedPostTimeExist", function () {
      if (_this.state.selectedQueue === null) {
        return false;
      }

      var selectedDay = _this.state.daysOfWeek[_this.state.selectedDayOfWeek];
      var selectedTime = _this.state.timesOfDay[_this.state.selectedTimeOfDay];
      var postTimes = _this.props.queues[_this.state.selectedQueue].QueuePostTimes;
      return postTimes.some(function (pt) {
        return pt.timeOfDay === selectedTime.id && pt.weekday === selectedDay.id;
      });
    });

    _this.state = {
      open: false,
      selectedQueue: null,
      horizontalOffset: 36,
      selectedDayOfWeek: 0,
      selectedTimeOfDay: 0,
      isAddingQueuePostTime: false,
      addingQueuePostTimeError: false,
      left: 36,
      queueWidth: 100,
      innerWrapWidth: 10000,
      showAddTimeDialog: false,
      daysOfWeek: [{
        id: 7,
        title: 'Sunday'
      }, {
        id: 1,
        title: 'Monday'
      }, {
        id: 2,
        title: 'Tuesday'
      }, {
        id: 3,
        title: 'Wednesday'
      }, {
        id: 4,
        title: 'Thursday'
      }, {
        id: 5,
        title: 'Friday'
      }, {
        id: 6,
        title: 'Saturday'
      }],
      timesOfDay: [{
        id: 1,
        title: 'Morning'
      }, {
        id: 2,
        title: 'Afternoon'
      }, {
        id: 3,
        title: 'Evening'
      }]
    };
    return _this;
  }

  _createClass(QueueFlyout, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var hasQueues = !!this.props.queues.length;
      var innerWrapWidth = 325 * (this.state.selectedQueue !== null && hasQueues ? this.props.queues[this.state.selectedQueue].Posts.length : 0);
      var addTimeActions = [/*#__PURE__*/React.createElement(GrayButton, {
        label: "Cancel",
        theme: this.props.theme,
        style: {
          marginRight: 24
        },
        onClick: function onClick() {
          return _this2.setState({
            showAddTimeDialog: false,
            selectedDayOfWeek: 0,
            selectedTimeOfDay: 0,
            isAddingQueuePostTime: false,
            addingQueuePostTimeError: false
          });
        }
      }), /*#__PURE__*/React.createElement(SecondaryButton, {
        theme: this.props.theme,
        disabled: this.state.isAddingQueuePostTime || this.doesSelectedPostTimeExist(),
        label: "Add",
        onClick: this.addQueuePostTime
      })];
      var atEnd = this.state.queueWidth > this.state.innerWrapWidth || this.state.innerWrapWidth + this.state.left < this.state.queueWidth;
      var postTimeChips = this.state.selectedQueue !== null && this.props.queues[this.state.selectedQueue].QueuePostTimes ? this.props.queues[this.state.selectedQueue].QueuePostTimes.map(function (qpt, idx) {
        return /*#__PURE__*/React.createElement(LLChip, {
          key: idx,
          theme: _this2.props.theme,
          label: _this2.formatPostTimeChipLabel(qpt),
          style: {
            marginRight: 18
          },
          onRequestDelete: function onRequestDelete() {
            _this2.removeQueuePostTime(qpt, _this2.props.organization.id);
          }
        });
      }) : null; // sort postTimeChips by day and/or time

      if (postTimeChips) {
        var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        var timeNames = ['Morning', 'Afternoon', 'Evening'];
        postTimeChips = postTimeChips.sort(function (a, b) {
          var aDayName = a.props.label.split(' ')[0];
          var bDayName = b.props.label.split(' ')[0];
          var aTimeName = a.props.label.split(' ')[1];
          var bTimeName = b.props.label.split(' ')[1];

          if (aDayName === bDayName) {
            return timeNames.indexOf(aTimeName) > timeNames.indexOf(bTimeName);
          }

          return dayNames.indexOf(aDayName) > dayNames.indexOf(bDayName);
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.flyout, " ").concat(this.state.open && this.props.queues.length ? styles.open : '')
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.tabs
      }, this.props.queues.map(function (queue, index) {
        return /*#__PURE__*/React.createElement(QueueFlyoutTab, {
          isSelected: _this2.state.selectedQueue !== null && _this2.props.queues[_this2.state.selectedQueue].id === queue.id,
          label: _this2.renderTabLabel(queue),
          key: index,
          onClick: function onClick() {
            return _this2.handleTabClick(index);
          }
        });
      })), this.state.selectedQueue !== null && this.props.queues[this.state.selectedQueue].Posts.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: styles.postTimeSection
      }, /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          margin: 0
        }
      }, postTimeChips && postTimeChips.length > 0 && /*#__PURE__*/React.createElement("span", {
        className: styles.postTimeHeader
      }, "Post Times:"), postTimeChips && postTimeChips.length > 0 ? postTimeChips : /*#__PURE__*/React.createElement("p", {
        style: {
          color: this.props.theme.colors.gray1,
          margin: '5px 0'
        }
      }, "Content in this Queue will not be posted until you add a Post Time.", ' ', /*#__PURE__*/React.createElement("a", {
        style: {
          cursor: 'pointer',
          color: this.props.theme.colors.primaryColor,
          textDecoration: 'underline'
        },
        onClick: function onClick() {
          return _this2.setState({
            showAddTimeDialog: true
          });
        }
      }, "Add one now.")), postTimeChips && postTimeChips.length > 0 && /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-plus ".concat(styles.addBtn),
        onClick: function onClick() {
          return _this2.setState({
            showAddTimeDialog: true
          });
        }
      }))), this.props.loadingQueues ? /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })) : /*#__PURE__*/React.createElement("div", {
        className: styles.postList
      }, this.state.selectedQueue !== null ? /*#__PURE__*/React.createElement(Measure, {
        whitelist: ['width'],
        onMeasure: function onMeasure(dimensions) {
          _this2.setState({
            queueWidth: dimensions.width - 70
          });
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.wrap,
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.outerWrap,
        style: {
          width: this.state.queueWidth
        }
      }, this.state.left !== 36 && /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.control, " ").concat(styles.leftControl),
        onClick: this.handleLeftNav
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-arrow-back"
      })), !atEnd && /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles.control, " ").concat(styles.rightControl),
        onClick: this.handleRightNav
      }, /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-arrow-forward"
      })), this.props.queues[this.state.selectedQueue].Posts.length ? /*#__PURE__*/React.createElement("div", {
        className: styles.innerWrap,
        style: {
          left: this.state.left,
          width: innerWrapWidth
        }
      }, this.props.queues[this.state.selectedQueue].Posts.map(function (post, index) {
        return /*#__PURE__*/React.createElement(HorizontalPostCard, {
          key: index,
          post: post,
          network: _this2.state.selectedQueue !== null && _this2.props.queues[_this2.state.selectedQueue].SocialAccounts && _this2.props.queues[_this2.state.selectedQueue].SocialAccounts.length ? _this2.props.queues[_this2.state.selectedQueue].SocialAccounts[0].platform : ''
        });
      })) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
        style: {
          color: this.props.theme.colors.gray1,
          marginLeft: 36
        }
      }, "Once you add content to your queue, we can post it for you."))), /*#__PURE__*/React.createElement(Dialog, {
        actions: addTimeActions,
        open: this.state.showAddTimeDialog,
        title: "Add A Post Time",
        onRequestClose: function onRequestClose() {
          return _this2.setState({
            showAddTimeDialog: false
          });
        }
      }, this.renderAddTimeDialog()))) : null));
    }
  }]);

  return QueueFlyout;
}(Component)) || _class);
export { QueueFlyout as default };